"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _lodash = _interopRequireWildcard(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _config = require("../config");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _helpers = require("react-platform-components/dist/helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var reviewOfProductConfig;
var ProductReviewsDialogContent;
try {
  reviewOfProductConfig = require('react-platform-review-of-product/dist/ReviewOfProduct/Recieved/RecievedReviewOfProductConfig').RecievedReviewOfProductConfig;
  ProductReviewsDialogContent = require("react-platform-review-of-product/dist/ReviewOfProduct/ReviewOfProductDialog").ProductReviewsDialogContent;
} catch (error) {}
var ProductFeaturing;
try {
  ProductFeaturing = require("react-platform-productfeature/dist/ProductFeaturing/ProductFeaturingDialog").ProductFeaturing;
} catch (error) {}
function ProductList(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var products = props.products,
    classes = props.classes,
    openConfirmDialog = props.openConfirmDialog,
    openEdit = props.openEdit,
    detailEndpoint = props.detailEndpoint,
    _props$extraProps = props.extraProps,
    extraProps = _props$extraProps === void 0 ? {} : _props$extraProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showProductReviews = _useState2[0],
    setShowProductReviews = _useState2[1];
  var handleProductReviewsList = function handleProductReviewsList(productId) {
    dispatch({
      type: "FETCH_PRODUCTS_REVIEWS",
      params: {
        "product.id": productId
      },
      endpoint: 'public-products-reviews'
    });
    setShowProductReviews(true);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, products.map(function (product) {
    var isFeatured = product.tags.find(function (tag) {
      return tag.uuid === _config.PRODUCT_FEATURED_TAG_UUID;
    });
    var image = null;
    if (!_lodash.default.isEmpty(product === null || product === void 0 ? void 0 : product.main_image)) {
      if (_config.PRODUCTS_LIST_FIELDS.includes("main_image")) {
        image = product.main_image.name["500x500"];
      }
    } else {
      if (!_lodash.default.isEmpty(product === null || product === void 0 ? void 0 : product.images)) {
        image = product.images[0].name["500x500"];
      }
    }
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      lg: 4,
      md: 6,
      xs: 12,
      className: classes.card,
      key: product.id
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      className: classes.cardShadow
    }, /*#__PURE__*/_react.default.createElement(_core.CardContent, {
      className: "sm:h-64 md:h-56"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 8
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h5",
      style: {
        overflowWrap: 'break-word'
      }
    }, (0, _lodash.truncate)(product.name || product.title, {
      length: 17
    }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 4,
      container: true,
      justify: "flex-end",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_core.Chip, {
      label: product.translated_status,
      color: product.status === 'published' ? 'primary' : 'default',
      variant: "outlined"
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      style: {
        marginTop: 16
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "subtitle1"
    }, " ", (0, _lodash.truncate)(product.description, {
      length: 35
    }), " ")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, !_lodash.default.isEmpty(image) ? /*#__PURE__*/_react.default.createElement("img", {
      style: {
        height: "220px",
        width: "250px",
        objectFit: "cover"
      },
      src: (0, _helpers.joinPaths)(_config.BASE_URL, image)
    }) : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: "220px",
        width: "250px",
        objectFit: "cover"
      }
    })))), /*#__PURE__*/_react.default.createElement(_core.CardActions, {
      style: {
        justifyContent: 'flex-end',
        marginTop: "50px"
      }
    }, ProductFeaturing && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isFeatured ? /*#__PURE__*/_react.default.createElement(_core.Chip, {
      label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "featured",
        defaultMessage: "featured"
      }),
      variant: "outlined"
    }) : /*#__PURE__*/_react.default.createElement(ProductFeaturing, {
      productId: product.id
    })), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: openConfirmDialog(product)
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "delete")), reviewOfProductConfig && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: function onClick() {
        return handleProductReviewsList(product.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "star_rate")), _config.PRODUCTS_CREATION_TYPE === 'dialog' ? /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: openEdit(product)
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "edit")) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: "no-underline",
      to: "/".concat(extraProps.productCreationEndpoint || _config.PRODUCTS_CREATION_ENDPOINT, "/").concat(product.id)
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, null, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "edit"))), _config.REACT_PRODUCT_DETAIL_ENDPOINT ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: "/".concat(detailEndpoint, "/").concat(product.id)
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, null, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "remove_red_eye"))) : /*#__PURE__*/_react.default.createElement("a", {
      href: "".concat(_config.BASE_URL).concat(_config.PRODUCT_DETAIL_ENDPOINT, "/").concat(product.id),
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, null, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "remove_red_eye"))))));
  }), ProductReviewsDialogContent && showProductReviews && /*#__PURE__*/_react.default.createElement(ProductReviewsDialogContent, {
    open: showProductReviews,
    onClose: function onClose() {
      return setShowProductReviews(false);
    }
  }));
}
var _default = ProductList;
exports.default = _default;